import { mapSceneBackgroundProvider } from "./backgrounds/mapSceneBackgroundProvider";
import { createGetSceneBackground } from "./createGetSceneBackground";
export var GetSceneBackground = createGetSceneBackground(mapSceneBackgroundProvider);



//////////////////
// WEBPACK FOOTER
// ./src/graphics/GetSceneBackground.ts
// module id = 2180
// module chunks = 3